<template>
    <div class="message">
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('normal_s.service_link')">
                <Input v-model="service_link"></Input>
            </FormItem>
            <FormItem :label="$t('normal_s.register')">
                <Input v-model="register"></Input>
            </FormItem>
            <FormItem :label="$t('normal_s.withdraw_fee')">
                <Input v-model="withdraw_fee">
                  <span slot="append">%</span>
                </Input>
            </FormItem>
            <FormItem :label="$t('normal_s.about_us')">
                <div id="about_usEditor"></div>
            </FormItem>
            <!--FormItem :label="$t('normal_s.agreement')">
                <div id="agreementEditor"></div>
            </FormItem>
            <FormItem :label="$t('normal_s.privacy_treaty')">
                <div id="privacy_treatyEditor"></div>
            </FormItem>
            <FormItem :label="$t('normal_s.user_item')">
                <div id="user_itemEditor"></div>
            </FormItem-->
            <!--FormItem :label="$t('normal_s.api_sq_text')">
                <div id="api_sq_textEditor"></div>
            </FormItem>
            <FormItem :label="$t('normal_s.api_text')">
                <div id="api_textEditor"></div>
            </FormItem-->
            <!--FormItem :label="$t('normal_s.huilv_text')">
                <div id="huilv_textEditor"></div>
            </FormItem>
            <FormItem :label="$t('normal_s.refund_text')">
                <div id="refund_textEditor"></div>
            </FormItem-->
            <!--FormItem :label="$t('normal_s.shouquan_text')">
                <div id="shouquan_textEditor"></div>
            </FormItem-->
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
            </FormItem>
        </Form>
    </div>
</template>

<script>
let E = require("wangeditor");
export default {
    data() {
        return {
            formItem: {},
            about_usEditor: null,
            agreementEditor: null,
            privacy_treatyEditor: null,
            user_itemEditor: null,
            api_sq_textEditor: null,
            api_textEditor: null,
            huilv_textEditor: null,
            refund_textEditor: null,
            shouquan_textEditor: null,
            dataLoaded: false,
            service_link: "",
            register: "",
            withdraw_fee: ""
        };
    },
    mounted(){
        this.init_editor();
        this.loadData();
    },
    methods: {
        doPost() {
            this.formItem.service_link = this.service_link;
            this.formItem.register = this.register;
            this.formItem.withdraw_fee = this.withdraw_fee;
            this.formItem.about_us = this.about_usEditor.txt.html();
            //this.formItem.agreement = this.agreementEditor.txt.html();
            //this.formItem.privacy_treaty = this.privacy_treatyEditor.txt.html();
            //this.formItem.user_item = this.user_itemEditor.txt.html();
            //this.formItem.api_sq_text = this.api_sq_textEditor.txt.html();
            //this.formItem.api_text = this.api_textEditor.txt.html();
            this.formItem.huilv_text = this.huilv_textEditor.txt.html();
            this.formItem.refund_text = this.refund_textEditor.txt.html();
            //this.formItem.shouquan_text = this.shouquan_textEditor.txt.html();
            //console.log(this.formItem);
            this.$post(this.$path.get_normal_data, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success('修改成功');
                } else {
                    this.$Message.error('修改失败');
                    console.error(res);
                }
            });
        },
        loadData() {
            this.$get(this.$path.get_normal_data, {

            }).then(res => {
                if (res.data) {
                    const common_map = new Map(res.data.map(rd => [rd.ckey, rd.text]));
                    this.service_link = common_map.get('service_link');
                    this.register = common_map.get('register');
                    this.withdraw_fee = common_map.get('withdraw_fee');

                    this.$nextTick(() => {
                        this.formItem.about_us = common_map.get('about_us');
                        //this.formItem.agreement = common_map.get('agreement');
                        //this.formItem.privacy_treaty = common_map.get('privacy_treaty');
                        //this.formItem.user_item = common_map.get('user_item');
                        //this.formItem.api_sq_text = common_map.get('api_sq_text');
                        //this.formItem.api_text = common_map.get('api_text');
                        this.formItem.huilv_text = common_map.get('huilv_text');
                        this.formItem.refund_text = common_map.get('refund_text');
                        //this.formItem.shouquan_text = common_map.get('shouquan_text');
                    });

                    // 将富文本内容设置到编辑器（延迟到编辑器创建后）
                    if (this.dataLoaded) {
                        this.setEditorContent();
                    }
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        },
        init_editor() {
            this.about_usEditor = new E("#about_usEditor");
            this.about_usEditor.create();

            this.agreementEditor = new E("#agreementEditor");
            this.agreementEditor.create();

            this.privacy_treatyEditor = new E("#privacy_treatyEditor");
            this.privacy_treatyEditor.create();

            this.user_itemEditor = new E("#user_itemEditor");
            this.user_itemEditor.create();

            this.api_sq_textEditor = new E("#api_sq_textEditor");
            this.api_sq_textEditor.create();

            this.api_textEditor = new E("#api_textEditor");
            this.api_textEditor.create();

            this.huilv_textEditor = new E("#huilv_textEditor");
            this.huilv_textEditor.create();

            this.refund_textEditor = new E("#refund_textEditor");
            this.refund_textEditor.create();

            this.shouquan_textEditor = new E("#shouquan_textEditor");
            this.shouquan_textEditor.create();

            // 标记编辑器已创建
            this.dataLoaded = true;

            // 如果数据已经加载，设置编辑器内容
            if (this.formItem.about_us || this.formItem.huilv_text || this.formItem.refund_text) {
                this.setEditorContent();
            }
        },
        setEditorContent() {
            // 延迟设置编辑器内容，确保编辑器已完全初始化
            this.$nextTick(() => {
                if (this.about_usEditor) {
                    this.about_usEditor.txt.html(this.formItem.about_us || '');
                }
                if(this.agreementEditor) {
                  this.agreementEditor.txt.html(this.formItem.agreement || '');
                }
                if(this.privacy_treatyEditor) {
                  this.privacy_treatyEditor.txt.html(this.formItem.privacy_treaty || '');
                }
                if(this.user_itemEditor) {
                  this.user_itemEditor.txt.html(this.formItem.user_item || '');
                }
                if(this.api_sq_textEditor){
                  this.api_sq_textEditor.txt.html(this.formItem.api_sq_text);
                }
                if(this.api_textEditor){
                  this.api_textEditor.txt.html(this.formItem.api_text || '');
                }
                if (this.huilv_textEditor) {
                    this.huilv_textEditor.txt.html(this.formItem.huilv_text || '');
                }
                if (this.refund_textEditor) {
                    this.refund_textEditor.txt.html(this.formItem.refund_text || '');
                }
                if(this.shouquan_textEditor) {
                  this.shouquan_textEditor.txt.html(this.formItem.shouquan_text || '');
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/system/normal.vue